<template>
  <!-- BEGIN #modalPosItem -->
  <b-modal
    modal-class="modal-pos-item"
    :hide-header="true"
    :hide-footer="true"
    size="lg"
    body-class="p-0"
    id="modalPosItem"
    centered
  >
    <form>
      <a href="#" class="close" @click="$emit('close')"
        ><i class="fa fa-times"></i
      ></a>
      <div class="pos-product" v-for="(p, index) in selectedProduct">
        <div class="pos-product-img">
          <img
            class="img"
            v-lazy="{
              src: p.photo,
              error: require('@/assets/default-product.jpg')
            }"
          />
        </div>
        <div class="pos-product-info">
          <div class="title">
            {{ p.product_name_kh ? p.product_name_kh : p.product_name_en }}
          </div>
          <div class="desc">
            {{ p.product_name_en }}
          </div>
          <div class="price">
            {{ defaultCurrency }}
            {{ defaultPrice(p.product_id, dataSend.guest_level_id) }}
          </div>
          <b-alert
            v-if="
              getPromotionDiscountDisplay(
                p.product_id,
                saleCodeByDefaultUom(p.product_id)
                  ? saleCodeByDefaultUom(p.product_id).unit_of_measure.uom_id
                  : 0,
                tableSelected.guest_level_id
              )
            "
            variant="info"
            show
          >
            {{
              getPromotionDiscountDisplay(
                p.product_id,
                saleCodeByDefaultUom(p.product_id)
                  ? saleCodeByDefaultUom(p.product_id).unit_of_measure.uom_id
                  : 0,
                tableSelected.guest_level_id
              )
            }}
          </b-alert>
          <b-alert
            v-if="
              getPromotionBuyItemFreeItem(
                p.product_id,
                saleCodeByDefaultUom(p.product_id)
                  ? saleCodeByDefaultUom(p.product_id).unit_of_measure.uom_id
                  : 0
              )
            "
            variant="success"
            show
          >
            Buy
            <strong>
              {{
                getPromotionBuyItemFreeItem(
                  p.product_id,
                  saleCodeByDefaultUom(p.product_id)
                    ? saleCodeByDefaultUom(p.product_id).unit_of_measure.uom_id
                    : 0
                ).free_item.buy_quantity
              }}
            </strong>
            Get Promotion
            {{
              getPromotionBuyItemFreeItem(
                p.product_id,
                saleCodeByDefaultUom(p.product_id)
                  ? saleCodeByDefaultUom(p.product_id).unit_of_measure.uom_id
                  : 0
              ).free_item.condition_type
            }}
            Item.
            <br />
            <table width="100%" class="text-primary">
              <tr>
                <th>Item Name</th>
                <th class="text-center">QTY</th>
                <th class="text-right">Price</th>
              </tr>
              <tr
                v-for="(item, index) in getPromotionBuyItemFreeItem(
                  p.product_id,
                  saleCodeByDefaultUom(p.product_id)
                    ? saleCodeByDefaultUom(p.product_id).unit_of_measure.uom_id
                    : 0
                ).free_item.free_item_list"
                :key="index"
              >
                <td>{{ item.product_name_free_en }}</td>
                <td class="text-center">{{ item.free_quantity }}</td>
                <td class="text-right">{{ item.price }}</td>
              </tr>
            </table>
          </b-alert>
          <hr />
          <div class="option-row">
            <div class="qty">
              <div class="input-group">
                <a
                  href="#"
                  class="btn btn-default"
                  @click.prevent="$emit('decrement')"
                  :disabled="quantity <= 1"
                  ><i class="fa fa-minus"></i
                ></a>
                <input
                  type="text"
                  class="form-control border-0 text-center"
                  :value="quantity"
                  @input="$emit('update-quantity', $event.target.value)"
                  style="padding: 0"
                />
                <a
                  href="#"
                  class="btn btn-default"
                  @click.prevent="$emit('increment')"
                  ><i class="fa fa-plus"></i
                ></a>
              </div>
            </div>
          </div>
          <div class="option-row" style="width: 94px">
            <input
              autofocus
              type="number"
              class="form-control text-center"
              :value="discountRate"
              @input="$emit('update-discount-rate', $event.target.value)"
              placeholder="Dis %"
              disabled
            />
          </div>
          <div class="option-row">
            <div class="option-title">
              {{ $t('restaurantSale.size') }}
            </div>
            <div class="option-list" v-if="p.sale_code.length > 0">
              <div
                class="option ts-cursor-pointer"
                v-for="(s, index) in orderBy(p.sale_code)"
                :key="s.pro_sale_code_id"
              >
                <input
                  type="radio"
                  :id="'size' + s.pro_sale_code_id"
                  :checked="size === s.unit_of_measure.uom_id"
                  :value="s.unit_of_measure.uom_id"
                  class="option-input"
                  @change="$emit('choose-size', s)"
                />
                <label class="option-label ts-cursor-pointer" :for="'size' + s.pro_sale_code_id">
                  <span class="option-text">{{
                    s.unit_of_measure.uom_name_en
                  }}</span>
                  <span class="option-price"
                    >{{ defaultCurrency }}
                    {{
                      defaultPrice(s.product_id, dataSend.guest_level_id, s.uom_id)
                    }}</span
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="option-row" v-if="p.product_add_on.length > 0">
            <div class="option-title">
              {{ $t('restaurantSale.addOn') }}
            </div>
            <div class="option-list">
              <div class="option ts-cursor-pointer" v-for="(add_on, index) in p.product_add_on">
                <input
                  type="checkbox"
                  :checked="isAddonSelected(add_on)"
                  :value="add_on"
                  class="option-input"
                  :id="'addon' + add_on.addon_pro_sale_code_id"
                  @change="toggleAddon(add_on)"
                />
                <label
                  class="option-label ts-cursor-pointer"
                  :for="'addon' + add_on.addon_pro_sale_code_id"
                >
                  <span class="option-text">{{
                    add_on.sale_code
                      ? add_on.sale_code.product.product_name_en
                      : ''
                  }}</span>
                  <span class="option-price"
                    >+ {{ defaultCurrency }}
                    {{
                      add_on.sale_code
                        ? add_on.sale_code.product_price
                          ? add_on.sale_code.product_price.sale_price
                          : 0
                        : ''
                    }}</span
                  >
                </label>
              </div>
            </div>
          </div>
          <div class="option-row">
            <textarea
              rows="2"
              class="form-control"
              :value="remarks"
              @input="$emit('update-remarks', $event.target.value)"
              :placeholder="$t('restaurantSale.remarks')"
            ></textarea>
          </div>
          <div class="btn-row">
            <a
              href="#"
              class="btn btn-default"
              data-dismiss="modal"
              @click.prevent="$emit('close')"
              >{{ $t('restaurantSale.cancel') }}</a
            >
            <ts-button
              type="submit"
              color="success"
              @click.prevent="$emit('add-to-cart')"
              >{{ $t('restaurantSale.addToCart') }}
              <i class="fa fa-plus fa-fw ml-2"></i
            ></ts-button>
          </div>
        </div>
      </div>
    </form>
  </b-modal>
  <!-- END #modalPosItem -->
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductModal',
  props: {
    selectedProduct: Array,
    dataSend: Object,
    defaultCurrency: String,
    quantity: Number,
    discountRate: Number,
    size: Number,
    addon: Array,
    remarks: String
  },
  computed: {
    ...mapGetters('restaurantSale/customerOrder', [
      'defaultPrice',
      'saleCodeByDefaultUom',
      'getPromotionDiscountDisplay',
      'getPromotionBuyItemFreeItem'
    ]),
    tableSelected() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
  },
  methods: {
    isAddonSelected(add_on) {
      return this.addon ? this.addon.includes(add_on) : false
    },
    toggleAddon(add_on) {
      const newAddon = this.addon ? [...this.addon] : []
      const index = newAddon.indexOf(add_on)

      if (index > -1) {
        newAddon.splice(index, 1)
      } else {
        newAddon.push(add_on)
      }

      this.$emit('update-addon', newAddon)
    },
    orderBy(sale_code) {
      return [...sale_code].sort(
        (a, b) => a.product_price.sale_price - b.product_price.sale_price
      )
    }
  }
}
</script>

<style scoped>
.pos-product-img .img {
  object-fit: cover;
  width: 100%;
}
</style>
